@if (standingsData) { @if ( standingsData[0] && standingsData[0].valueTypes && standingsData[0].valueTypes.competitors )
{
<div class="match-info-head text-white mb-0 bg-dark p-2 d-flex">
    <span class="font-weight-bold text-uppercase"
        >{{ 'web.seasonal-statistics' | translate }} {{ standingsData[0].description }}</span
    >
</div>
<div class="mb-3 bg-white">
    <div class="collapse show" id="collapse-drivers">
        <div class="table-responsive">
            <table class="table table-sm stage-table">
                <thead>
                    <tr class="bg-light2">
                        <td class="small align-middle">{{ 'web.year' | translate }}</td>
                        <td class="small align-middle">#</td>
                        @for (valueType of standingsData[0].valueTypes.competitors; track $index) {
                        <td class="small align-middle">
                            {{ 'stagevaluetype.' + standingsData[0].category + '_' + valueType | translate }}
                        </td>
                        }
                    </tr>
                </thead>
                <tbody>
                    @for (row of standingsData; track $index) {
                    <tr>
                        <td class="align-middle">
                            {{ row.year }}
                        </td>
                        <td class="align-middle">
                            @if (row.position) {
                            {{ row.position }}. }
                        </td>
                        @for (valueType of row.valueTypes.competitors; track $index) {
                        <td class="align-middle">
                            @if (row.values[valueType]) {
                            {{ row.values[valueType] }}
                            } @else { - }
                        </td>
                        }
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
</div>
} } @else {
<app-page-loader></app-page-loader>
}
